export default "__VITE_ASSET__11b155ef__"